<div>
  <div class="user-consent-confirmation-headline">
    <h2>
      {{ 'register.userConsentConfirmation.welcomeHeadline' | transloco }}
    </h2>
  </div>
  <div class="user-consent-confirmation-text">
    {{ 'register.userConsentConfirmation.userConsentContent' | transloco }}
  </div>

  <div class="user-consent-confirmation-checkbox">
    <markant-checkbox
      data-cy="consent-information-checkbox"
      [formControl]="formControl"
    ></markant-checkbox>
    <div class="user-consent-confirmation-checkbox-text">
      <div class="conditions-of-use-label">
        {{ 'register.userConsentConfirmation.preCheckboxLabel' | transloco }}
        <a
          *ngIf="termsOfUseLink$ | async as termsOfUse"
          [href]="termsOfUse.href"
          [target]="termsOfUse.target"
          data-cy="terms-of-use-link-anchor"
          >{{
            'register.userConsentConfirmation.linkTextTermsOfUse' | transloco
          }}</a
        >
        {{ 'register.userConsentConfirmation.postCheckboxLabel' | transloco }}*
      </div>
      <div
        [style.visibility]="
          showError && !formControl.value ? 'visible' : 'hidden'
        "
        class="error-container"
      >
        <markant-icon
          class="error-message-icon"
          icon="m_warning"
          colorScheme="primary"
        ></markant-icon>
        <span class="error_message">
          {{ 'register.user.legalDocumentsHelperText' | transloco }}
        </span>
      </div>
      <div>
        <div>
          {{
            'register.userConsentConfirmation.prePrivacyPolicyLabel' | transloco
          }}
          <a
            *ngIf="privacyPolicyLink$ | async as privacyPolicy"
            [href]="privacyPolicy.href"
            [target]="privacyPolicy.target"
            >{{
              'register.userConsentConfirmation.linkTextPrivacyPolicy'
                | transloco
            }}</a
          >
          {{
            'register.userConsentConfirmation.postPrivacyPolicyLabel'
              | transloco
          }}
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-content button-user-consent">
    <markant-button
      data-cy="confirm-user-consent-button"
      colorScheme="primary"
      (click)="confirmUserConsent()"
    >
      <span>{{ 'general.next' | transloco }}</span>
    </markant-button>
  </div>
</div>
